import React, { useEffect, useState } from 'react';
import background from './websitebg.png';
import sneakpeek1 from './sneak-peeks/sneak-1.png';
import sneakpeek2 from './sneak-peeks/sneak-2.png';
import sneakpeek3 from './sneak-peeks/sneak-3.png';
import TwitterIcon from './icons8-twitter.svg';
import OsLogo from './opensea-logo.svg';
import EtherscanLogo from './etherscan-logo-circle.svg'
import Web3 from 'web3';
let mintContractJson = require('./abi/GhostGoblins.json');

const MintPage = () => {

  useEffect(() => {
    const getData = async() => {
      await getTotalSupply();
    }
    getData();
  }, [])

  const [totalSupply, setTotalSupply] = useState(0);
  const [mintTotal, setMintTotal] = useState(0);
  const [active, setActive] = useState(false);
  const [account, setAccount] = useState('');
  const [hash, setHash] = useState('');

  const handleButton = (op) => {
    let total = mintTotal;
    if (op === '+' && total < 1) {
      total++;
      setMintTotal(total);
    } else if (op === '-' && total > 0) {
      total--;
      setMintTotal(total);
    }
  }

  const handleMint = async() => {
    if (!account || account === '') {
      alert('Connect Wallet');
      return;
    }
    if (mintTotal > 1) {
      alert('Max per tx is 1');
      return;
    }
    try {
      const web3 = await getWeb3Provider();
      const contract = new web3.eth.Contract(mintContractJson.output.abi, '0xcA43C1f7e4EFfbf9B9872a41E05c698941C996bb');
      let owned = await contract.methods.numberMinted(account).call();
      if (owned >= 2) {
        alert('Max per wallet is 2');
        return;
      }
      let totalItems =  parseInt(owned) + mintTotal;
      if (totalItems > 2) {
        alert('Max per wallet is 2');
        return;
      }
      let totalVal = 0;
      if (totalSupply >= 500) {
        totalVal = parseFloat('0.003') * mintTotal;
      }
      totalVal = totalVal.toString();
      const transaction = contract.methods.mint(mintTotal);
      const options = {
        from    : account,
        to      : '0xcA43C1f7e4EFfbf9B9872a41E05c698941C996bb',
        data    : transaction.encodeABI(),
        value   : web3.utils.toWei(totalVal, 'ether'),
        gas     : await transaction.estimateGas({from: account, value: web3.utils.toWei(totalVal, 'ether') }),
        gasPrice: await web3.eth.getGasPrice()
      };
      console.log('options: ', options);
      const receipt = await web3.eth.sendTransaction(options);
      setHash(receipt.transactionHash);
      console.log('receipt: ', receipt);
    } catch (e) {
      console.log(e);
      alert(e);
    }
  }

  const getTotalSupply = async() => {
    const web3 = await getWeb3Provider();
    const contract = new web3.eth.Contract(mintContractJson.output.abi, '0xcA43C1f7e4EFfbf9B9872a41E05c698941C996bb');
    const result = await contract.methods.totalSupply().call({ from: account });
    setTotalSupply(result);
  }

  const handleWalletConnect = async() => {
    let ethereum = window.ethereum;
    try {
    const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
    const account = accounts[0];
    setAccount(account);
    setActive(true);
    //accounted(account);
    } catch {
      alert('Enable Metamask');
    console.log("connect fail!");
    }
  }

  const getWeb3Provider = async() => {
    await window.ethereum.enable();
    window.web3 = new Web3(window.ethereum);
    return window.web3;
  }

  const renderSneakPeeks = () => {
    return (
      <div style={styles.sneakPeekContainer} className='sneak-peeks'>
        <img src={sneakpeek1} alt='Sneak peek 1' style={styles.sneakPeek} className='sneak-peek'/>
        <img src={sneakpeek2} alt='Sneak peek 2' style={styles.sneakPeek} className='sneak-peek'/>
        <img src={sneakpeek3} alt='Sneak peek 3' style={styles.sneakPeek} className='sneak-peek'/>
        {/*<img src={sneakpeek4} alt='Sneak peek 4' style={styles.sneakPeek} className='sneak-peek'/>
        <img src={sneakpeek5} alt='Sneak peek 5' style={styles.sneakPeek} className='sneak-peek'/>*/}
      </div>
    )
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#528aae', marginTop: '0'}}>
      <div style={styles.headerContainer}>
        <a href='https://opensea.io/collection/degen-diplomas' target='_blank' rel="noreferrer"><img src={OsLogo} alt='OS logo' style={styles.icon}/></a>
        <a href='https://etherscan.io/address/0xca43c1f7e4effbf9b9872a41e05c698941c996bb' target='_blank' rel="noreferrer"><img src={EtherscanLogo} alt='Etherscan logo' style={styles.icon}/></a>
        <button onClick={handleWalletConnect} style={styles.connectWalletButton}>{(account && account != '') ? account.substring(0,20) + '...' + account.slice(-3) : 'Connect Wallet'}</button>
      </div>
      <div style={styles.container}>
        <div>
          <h1 style={styles.title} className='title'>Degen Diplomas</h1>
          {renderSneakPeeks()}
          <h3 style={styles.subtitle} className='subtitle'>The Degenerate Academy Commencement Office<br></br>provides its heartfelt congratulations<br></br>to our graduates from the mighty class of 2022</h3>
        </div>
        <div>
          <p style={styles.body} className='text'>500 free! | Total Supply {totalSupply}/1500</p>
          <p style={styles.body} className='text'>Max Per Tx: 1 | Max Per Wallet: 2</p>
          <p style={styles.body} className='text'>Price: 0.003 eth</p>
        </div>
        <div style={styles.mintButtonContainer}>
          <button onClick={() => handleButton('-')} style={styles.numberButton}>-</button>
          <p style={styles.mintTotal}>{mintTotal}</p>
          <button onClick={() => handleButton('+')} style={styles.numberButton}>+</button>
        </div>
          <button onClick={handleMint} style={styles.mintButton}>Mint</button>
        </div>
      </div>
  )
}

const styles = {
  mintButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    display: 'table',
    margin: '0 auto',
    //paddingTop: '24px',
    textAlign: 'center',
    //backgroundImage: `url("./websitebg.png")`,
  },
  title: {
    fontSize: '96px',
    marginTop: '16px',
    marginBottom: '16px'
  },
  subtitle: {
    fontSize: '40px',
    marginTop: '24px',
    marginBottom: '8px'
  },
  body: {
    fontSize: '24px',
    margin: '16px 0'
  },
  mintTotal: {
    padding: '0 16px 0 16px',
    fontSize: '24px',
    marginTop: '0',
    marginBottom: '16px'
  },
  numberButton: {
    height: '24px',
    minWidth: '24px',
    borderRadius: '50%',
    border: 'none',
    padding: '0',
    backgroundColor: '#000000',
    color: '#FFFFFF',
    marginBottom: '16px'
  },
  mintButton: {
    width: '232px',
    height: '48px',
    backgroundColor: '#000000',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '8px',
    fontSize: '24px',
    marginBottom: '96px'
  },
  sneakPeek: {
    height: '200px', 
    width: '280px', 
    borderRadius: '8px', 
    border: '1px solid #707070',
    marginRight: '24px'
  },
  sneakPeekContainer: {
    display: 'flex',
    justifyContent: 'center',
    //marginTop: '72px'
  },
  icon: {
    height: '36px',
    width: '36px',
    paddingRight: '16px',
    paddingTop: '16px'
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'right'
  },
  connectWalletButton: {
    width: '264px',
    backgroundColor: '#000000',
    color: '#FFFFFF',
    fontSize: '16px',
    marginRight: '16px',
    borderRadius: '16px',
    border: 'none',
    padding: '8px 0 8px 0'
  }
}

export default MintPage;